import React from 'react';
import { styled } from 'styled-components';
import THEME from '../theme.js';
const PillSelector = (props) => {
    return (React.createElement(Wrapper, null, props.options.map((option) => {
        return (React.createElement(Option, { onClick: (e) => {
                props.onChange(option.value);
            }, selected: option.value === props.value }, option.label));
    })));
};
const Wrapper = styled.div `
  display: flex;
  align-items: center;
  width: 100%;
  font-size: 0.8em;
  overflow: hidden;
`;
const Option = styled.div `
  padding: 0.5em;

  background: #fff;
  text-align: center;
  width: 100%;
  cursor: pointer;
  background: ${(props) => (props.selected ? THEME.COLOR_ACCENT : '#FFF')};
  color: ${(props) => (props.selected ? '#FFF' : THEME.COLOR_PRIMARY)};
  border: 1px solid
    ${(props) => (props.selected ? THEME.COLOR_ACCENT : THEME.BORDER_STRONG)};
  border-left: none;
  &:first-of-type {
    border-radius: 0.5em 0 0 0.5em;
    border-left: 1px solid
      ${(props) => (props.selected ? THEME.COLOR_ACCENT : THEME.BORDER_STRONG)};
  }
  &:last-of-type {
    border-radius: 0 0.5em 0.5em 0;
    border-right: 1px solid
      ${(props) => (props.selected ? THEME.COLOR_ACCENT : THEME.BORDER_STRONG)};
  }
`;
export default PillSelector;
//# sourceMappingURL=PillSelector.js.map